import { IonCol, IonContent, IonGrid, IonRow } from "@ionic/react";
import Me from "../../Me/Me";
import TitlePage from "../../TitlePage/TitlePage";
import "./BasicPage.css";

interface Props {
  title: string;
  subtitle: string;
  pathReturn?: string;
  children: React.ReactNode;
  pathLogo: string;
  sizeLg?:
    | "1"
    | "2"
    | "3"
    | "4"
    | "5"
    | "6"
    | "7"
    | "8"
    | "9"
    | "10"
    | "11"
    | "12"
    | undefined;
  sizeSm?:
    | "1"
    | "2"
    | "3"
    | "4"
    | "5"
    | "6"
    | "7"
    | "8"
    | "9"
    | "10"
    | "11"
    | "12"
    | undefined;
}

const BasicPage: React.FC<Props> = ({
  title,
  subtitle,
  pathReturn,
  children,
  pathLogo,
  sizeLg,
  sizeSm,
}) => {
  return (
    <>
      <IonContent color="primary">
        <IonGrid>
          <Me pathReturn={pathReturn} />
          <IonRow className="ion-justify-content-center">
            <IonCol size-lg={sizeLg ?? "5"} size-sm={sizeSm ?? "10"}>
              <TitlePage title={title} subTitle={subtitle} />
              {children}
              {/* <IonRouterOutlet /> */}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </>
  );
};

export default BasicPage;
